import React, { useState } from 'react';

import NarrowWidth from '@/components/common/layout/NarrowWidth';

import css from './Collapsible.module.css';

const Collapsible = props => {
  const { collapsed_initially, collapsed_text, displayed_text } = props.value;

  const [hasText, setHasText] = useState(!collapsed_initially);

  const handelClick = () => {
    setHasText(!hasText);
  };

  return (
    <NarrowWidth>
      <div
        className={`grid grid-cols-1 gap-8 mb-8 md:mb-12 w-full ${css.collapsible} ${css.maxCharacterCount}`}>
        <h3
          className="flex items-center text-xl text-gray-800 cursor-pointer"
          onClick={handelClick}
          onKeyPress={handelClick}>
          {displayed_text}
          <span
            className={`inline-flex items-center ml-3 h-7 transform
                ${hasText ? 'rotate-180' : 'rotate-0'}`}>
            <svg className="w-6 h-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </span>
        </h3>
        {hasText && (
          <div
            className={`text-base text-gray-900`}
            dangerouslySetInnerHTML={{ __html: collapsed_text }}
          />
        )}
      </div>
    </NarrowWidth>
  );
};

export default Collapsible;
